import { useState, ReactNode } from 'react'
import Navbar from './Navbar'
import Sidebar from './Sidebar'
import { SidebarContext } from '../context/SidebarContext'
import { useIsMobile } from '../hooks/useIsMobile'

export default function Layout({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false)
  const isMobile = useIsMobile()

  return (
    <SidebarContext.Provider value={{
      open,
      toggle: () => setOpen(o => !o),
      close:  () => setOpen(false),
    }}>
      <div style={{ paddingTop: 64 }}>
        <Navbar />
        <Sidebar />

        {isMobile && open && (
          <div
            onClick={() => setOpen(false)}
            style={{
              position: 'fixed', top: 64, left: 0, right: 0, bottom: 0,
              background: 'rgba(0,0,0,0.5)', zIndex: 898,
            }}
          />
        )}

        <div style={{ marginLeft: isMobile ? 0 : 220 }}>
          {children}
        </div>
      </div>
    </SidebarContext.Provider>
  )
}
